// removed by extract-text-webpack-plugin
module.exports = {"selected-contanier":"selected-contanier___3HX7H","item-container":"item-container___3Yp_Y","del-icon":"del-icon___3m1kv"};


//////////////////
// WEBPACK FOOTER
// ./src/components_business/Address/SelectedPart/Index.less
// module id = cdTP
// module chunks = 0 9 12 13